import { useState } from 'react';
import { ClarityEvents } from '../../../lib/clarity/types/clarityEvents.types';
import { captureEventWithName } from '../../../lib/clarity/utils/captureEvent.utils';
import { useFindLatestHighlights } from '../../../services/modules/highlights/highlights.queries';
import { HighlightOutput } from '../../../services/modules/highlights/highlights.types';
import { useHighlightsReadState } from './useHighlightsReadState';

export const useHighlights = () => {
  const { data } = useFindLatestHighlights();
  const highlights = data ?? [];
  const { isRead, markAsRead } = useHighlightsReadState(
    highlights.map((highlight) => highlight.id),
  );
  const [openedHighlight, setOpenedHighlight] = useState<HighlightOutput | null>(null);
  const [isHighlightOpen, setIsHighlightOpen] = useState(false);

  const openHighlight = (highlight: HighlightOutput) => {
    const isFirstRead = !isRead(highlight.id);

    markAsRead(highlight.id);

    if (isFirstRead) {
      captureEventWithName(ClarityEvents.HIGHLIGHT_READ_WITH_TITLE, highlight.title);
    }

    setOpenedHighlight(highlight);
    setIsHighlightOpen(true);
  };

  const closeHighlight = () => setIsHighlightOpen(false);

  return { highlights, openedHighlight, isHighlightOpen, isRead, openHighlight, closeHighlight };
};
